import {
  changeOrderApiRequest,
  checkCouponApiRequest,
  checkOwnerProviderStriperCustomerApiRequest,
  createCustomerBillingInfoApiReqeust,
  getCategoriesApiRequest,
  getOwnerSubscriptionsApiRequest,
  getProviderDetailsApiRequest,
  getResourcesApiRequest,
  insertProviderImageApiRequest,
  sendBillingInfoToBackEndAndSubscribeApiRequest,
  sendConfirmSubB2bApiRequest,
  sendPaymentMethodToBackEndApiRequest,
  sendStripeAuthCodeApiReqeust,
  sendSubscribeToBackEndApiRequest,
  stripeCustomerAccountFromOtherProviderApiRequest,
} from '@guryou/api-client';

import { executeApiCall } from '../core';
import { PROVIDER_GET, PROVIDER_IMAGES_CREATE } from '../new';
import {
  CHANGE_ORDER,
  CHECK_COUPON,
  CREATE_CUSTOMER_BILLING_INFO_HANDLE,
  OWNER_PROVIDER_CHECK_STRIPE_CUSTOMER_HANDLE,
  OWNER_SUBSCRIPTIONS_GET,
  PROVIDER_CHECK_STRIPE_CUSTOMER_HANDLE,
  PROVIDER_GET_CATEGORIES,
  PROVIDER_GET_RESOURCES,
  SEND_BILLING_INFO_AND_SUBSCRIBE_HANDLE,
  SEND_CONFIRM_SUB_B2B_HANDLE,
  SEND_PAYMENT_METHOD_TOKEN_TO_BACKEND_HANDLE,
  SEND_STRIPE_AUTH_CODE,
  SEND_STRIPE_FROM_OTHER_PROVIDER_HANDLE,
  SEND_SUBSCRIBE_BACKEND_HANDLE,
} from '../types';

const twoUndefined = [undefined, undefined];

// getProviderBillingInfo;

const changeOrder = (arr, type) => async dispatch => dispatch(executeApiCall(changeOrderApiRequest(arr, type), CHANGE_ORDER));

const getProviderDetails = (providerId, silent) => async dispatch =>
  dispatch(executeApiCall(getProviderDetailsApiRequest(providerId), PROVIDER_GET, silent, undefined, true));

const getResources = () => async dispatch => dispatch(executeApiCall(getResourcesApiRequest(), PROVIDER_GET_RESOURCES, ...twoUndefined, true));

const getCategories = silent => async dispatch =>
  dispatch(executeApiCall(getCategoriesApiRequest(), PROVIDER_GET_CATEGORIES, silent, undefined, true));

// const deleteProviderImage = id => async dispatch => dispatch(executeApiCall(deleteProviderImageApiRequest(id), PROVIDER_IMAGES_DELETE));

const insertProviderImage = data => async dispatch => dispatch(executeApiCall(insertProviderImageApiRequest(data), PROVIDER_IMAGES_CREATE));

//duplicate - start
const checkOwnerProviderStriperCustomer = (id, silent) => async dispatch =>
  dispatch(executeApiCall(checkOwnerProviderStriperCustomerApiRequest(id), OWNER_PROVIDER_CHECK_STRIPE_CUSTOMER_HANDLE, silent, undefined, true));

const checkProviderStriperCustomer = (id, silent, providerId) => async dispatch =>
  dispatch(
    executeApiCall(checkOwnerProviderStriperCustomerApiRequest(id, providerId), PROVIDER_CHECK_STRIPE_CUSTOMER_HANDLE, silent, undefined, true)
  );
//duplicate - end

const stripeCustomerAccountFromOtherProvider = id => async dispatch =>
  dispatch(executeApiCall(stripeCustomerAccountFromOtherProviderApiRequest(id), SEND_STRIPE_FROM_OTHER_PROVIDER_HANDLE, ...twoUndefined, true));

const createCustomerBillingInfo =
  (data, providerId, noMessage = false) =>
  async dispatch =>
    dispatch(
      executeApiCall(createCustomerBillingInfoApiReqeust(data, providerId), CREATE_CUSTOMER_BILLING_INFO_HANDLE, undefined, undefined, noMessage)
    );

const sendPaymentMethodToBackEnd =
  (plan, customerId, paymentMethodId, coupon = false) =>
  async dispatch =>
    dispatch(
      executeApiCall(
        sendPaymentMethodToBackEndApiRequest(plan, customerId, paymentMethodId, coupon),
        SEND_PAYMENT_METHOD_TOKEN_TO_BACKEND_HANDLE,
        ...twoUndefined,
        false
      )
    );

const sendSubscribeToBackEnd = () => async dispatch => dispatch(executeApiCall(sendSubscribeToBackEndApiRequest(), SEND_SUBSCRIBE_BACKEND_HANDLE));

const sendBillingInfoToBackEndAndSubscribe = (plan, ownerId, providerId, customerId, customerName) => async dispatch =>
  dispatch(
    executeApiCall(
      sendBillingInfoToBackEndAndSubscribeApiRequest(plan, ownerId, providerId, customerId, customerName),
      SEND_BILLING_INFO_AND_SUBSCRIBE_HANDLE,
      ...twoUndefined,
      true
    )
  );
const sendConfirmSubB2b = (data, customMessage) => async dispatch =>
  dispatch(executeApiCall(sendConfirmSubB2bApiRequest(data), SEND_CONFIRM_SUB_B2B_HANDLE, undefined, undefined, customMessage));
// const getPlans = () => async dispatch => dispatch(executeApiCall(getPlansApiRequest(), GET_PLANS, ...twoUndefined, true));

const getOwnerSubscriptions = ownerId => async dispatch =>
  dispatch(executeApiCall(getOwnerSubscriptionsApiRequest(ownerId), OWNER_SUBSCRIPTIONS_GET, ...twoUndefined, true));

const sendStripeAuthCode = (auth_code, id) => async dispatch =>
  dispatch(executeApiCall(sendStripeAuthCodeApiReqeust(auth_code, id), SEND_STRIPE_AUTH_CODE));

const checkCoupon = (coupon, validMessage, invalidMessage, silent) => async dispatch =>
  dispatch(executeApiCall(checkCouponApiRequest(coupon, validMessage, invalidMessage), CHECK_COUPON, silent));

export {
  changeOrder,
  checkCoupon,
  checkOwnerProviderStriperCustomer,
  checkProviderStriperCustomer,
  createCustomerBillingInfo,
  getCategories,
  getOwnerSubscriptions,
  getProviderDetails,
  // deleteProviderImage,
  getResources,
  insertProviderImage,
  sendBillingInfoToBackEndAndSubscribe,
  sendConfirmSubB2b,
  sendPaymentMethodToBackEnd,
  sendStripeAuthCode,
  sendSubscribeToBackEnd,
  stripeCustomerAccountFromOtherProvider,
};
